import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/$locale/employer/$companyId/jobs/$jobId',
)({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === true,
  }),
})
